import { gql } from '@apollo/client';

export const VALIDATE_PROJECT_ID = gql`
  query Flex_ValidateProjectId($vnmSolarProjectId: Int, $utilityId: Int) {
    validation {
      vnmSolarProject(vnmSolarProjectId: $vnmSolarProjectId, utilityId: $utilityId) {
        isValid
        error {
          message
          status
        }
      }
    }
  }
`;
